<script lang="ts">
  import Text from '../../common/components/Text.svelte';
  import Timer from '../../common/components/Timer.svelte';
  import { productDetailMainData } from '../store/pdp_store';

  export let preorder = false;
  let dealEnd: Date | null = null;
  let dealTimerVisible = false;
  let dealTimerTextKey = '';

  $: {
    const isComingSoon = $productDetailMainData?.isComingSoon;
    const comingSoonDate = $productDetailMainData?.comingSoonDate;
    const comingSoonTimerDate = $productDetailMainData?.comingSoonTimerDate;
    const endDateDeal = $productDetailMainData?.endDateDeal;
    if (isComingSoon && (comingSoonDate || comingSoonTimerDate)) {
      if (comingSoonTimerDate) {
        dealEnd = new Date(comingSoonTimerDate);
      } else {
        const [day, month, year] = comingSoonDate.split('-').map(Number);
        dealEnd = new Date(year, month - 1, day);
      }
    } else if (endDateDeal) {
      dealEnd = new Date(endDateDeal);
    } else {
      dealEnd = null;
    }
    dealTimerVisible = dealEnd ? dealEnd.getTime() - Date.now() > 0 : false;
    dealTimerTextKey = preorder
      ? isComingSoon
        ? 'extra.preorder.start.text'
        : 'extra.preorder.ends.text'
      : isComingSoon
        ? 'extra.pdp.comingsoon'
        : 'extra.pdp.offerEndsIn';
  }
</script>

{#if dealEnd && dealTimerVisible}
  <div class="PDPdealTimer" class:isComingSoonBg={$productDetailMainData?.isComingSoon} class:preordertimer={preorder}>
    <div class="dealTimer_text">
      <Text key={dealTimerTextKey} />
    </div>
    <Timer {dealEnd} isPDPTimer={true} isComingSoon={$productDetailMainData?.isComingSoon} {preorder} />
  </div>
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .PDPdealTimer {
    gap: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: $functional-yellow;
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    margin-bottom: 4px;
    @include desktop-min-width {
      font-size: 24px;
      line-height: 26px;
    }
    &.preordertimer {
      &:not(.isComingSoonBg) {
        background: #04061b;
        color: #fff;
      }
    }
  }
</style>
